<button
    [id]="id()"
    [attr.data-testid]="id()"
    [attr.data-uiType]="'button'"
    (click)="submit()"
    [attr.data-styleTarget]="id()"
    [attr.data-styleDisabled]="fg.invalid || disabled()"
    [class.bg-dat-blue-500]="fg.valid && !disabled()"
    [class.bg-dat-grey-050]="fg.invalid || disabled()"
    [class.text-dat-grey-200]="fg.invalid || disabled()"
    [class.text-white]="fg.valid && !disabled()"
    [ngClass]="isPageControl ? 'rounded-md h-9 w-9 flex items-center justify-center mb-[18px] pt-2' : ''"
    [disabled]="fg.invalid || disabled()"
>
    <span
        [attr.data-testid]="id() + '-label'"
        [attr.data-uiType]="'label'"
        [attr.data-styleTarget]="id()"
        class="iq-md"
        [datiqTemplateMd]="label()"
    ></span>
</button>
